import languages from '../constants/languages';

const supportedLanguages = Object.values(languages);

const normalizeLanguage = languageCode => {
  if (!languageCode || typeof languageCode !== 'string') {
    return null;
  }

  return languageCode.toLowerCase().split(/[-_]/)[0];
};

const isSupportedLanguage = languageCode =>
  supportedLanguages.includes(normalizeLanguage(languageCode));

const getLanguageFromPath = pathname => {
  if (!pathname || typeof pathname !== 'string') {
    return null;
  }

  const [, maybeLanguage] = pathname.split('/');
  const normalizedLanguage = normalizeLanguage(maybeLanguage);

  return isSupportedLanguage(normalizedLanguage) ? normalizedLanguage : null;
};

const stripLanguageFromPath = pathname => {
  if (!pathname || typeof pathname !== 'string') {
    return '/';
  }

  const pathWithoutQueryOrHash = pathname.startsWith('/')
    ? pathname
    : `/${pathname}`;

  const languageFromPath = getLanguageFromPath(pathWithoutQueryOrHash);

  if (!languageFromPath) {
    return pathWithoutQueryOrHash;
  }

  const strippedPath = pathWithoutQueryOrHash.replace(
    new RegExp(`^/${languageFromPath}(?=/|$)`),
    '',
  );

  return strippedPath || '/';
};

const buildLocalizedPath = (pathname = '/', languageCode) => {
  const normalizedLanguage = normalizeLanguage(languageCode);
  const normalizedPathname = stripLanguageFromPath(pathname);

  if (!isSupportedLanguage(normalizedLanguage)) {
    return normalizedPathname;
  }

  if (normalizedPathname === '/') {
    return `/${normalizedLanguage}`;
  }

  return `/${normalizedLanguage}${normalizedPathname}`;
};

const replacePathLanguage = languageCode => {
  if (typeof window === 'undefined') {
    return;
  }

  const localizedPath = buildLocalizedPath(window.location.pathname, languageCode);
  const nextUrl = `${localizedPath}${window.location.search}${window.location.hash}`;

  if (
    localizedPath === window.location.pathname &&
    nextUrl === `${window.location.pathname}${window.location.search}${window.location.hash}`
  ) {
    return;
  }

  window.history.replaceState({}, '', nextUrl);
};

export {
  buildLocalizedPath,
  getLanguageFromPath,
  isSupportedLanguage,
  normalizeLanguage,
  replacePathLanguage,
  stripLanguageFromPath,
  supportedLanguages,
};